module.exports = __webpack_public_path__ + "img/logo12.2c28d451.png";